module.exports = __webpack_public_path__ + "static/media/bg.89a5539d.mp3";